import { Component, Input, OnInit, } from '@angular/core';

@Component({
    selector: 'core-rule-results-item',
    templateUrl: './rule-result-item.component.html',
    styleUrls: ['./rule-result-item.component.scss'],
    providers: []
})
export class CoreHelpersFormRuleResultsItemComponent implements OnInit{
    @Input() item: any;
    @Input() selected: boolean;

    public isHover: boolean = false;
    public color: any;

    constructor(){}

    ngOnInit(): void {
        this.color = this.hexToRgb(this.item.options.color);
        // console.log(" COLOR ",this.color)
    }

    // only toggle hover when hoverable is set
    toggleHover(hov: boolean){
        this.isHover = hov;
    }

    hexToRgb(hex) {
        var result = (/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i).exec(hex);
        return result ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16)
        } : null;
      }


}
